export enum AccomodationEnum {
  CAMPUS = 'CAMPUS',
  COLLEGE = 'COLLEGE',
  HOST_FAMILY = 'HOST_FAMILY',
  HOTEL = 'HOTEL',
  RESIDENCE = 'RESIDENCE'
}

export const accomodationEnumMapping: Record<AccomodationEnum, string> = {
  [AccomodationEnum.HOST_FAMILY]: 'Famille d’accueil',
  [AccomodationEnum.COLLEGE]: 'Collège',
  [AccomodationEnum.CAMPUS]: 'Campus',
  [AccomodationEnum.RESIDENCE]: 'Résidence',
  [AccomodationEnum.HOTEL]: 'Hôtel'
}
